/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";

import VCalendar from "v-calendar";
import HighchartsVue from 'highcharts-vue'
import vSelect from 'vue-select'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-select/dist/vue-select.css';

import "@/plugins/components";
import "@/plugins/icons";
import "@/plugins/cookies"
import "@/plugins/notification"

import lazyImage from '@/plugins/lazyImage.js'

import "@/styles/_index.scss"
import 'v-calendar/lib/v-calendar.min.css';

import router from "@/router";
import store from "@/store/index";

const token = window.getCookie('x-pulse-token');
if( token ) store.commit('user/setToken', token ) ;

Vue.use(VCalendar);
Vue.use(HighchartsVue);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.directive("lazyImage", lazyImage);
Vue.component('v-select', vSelect);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app")
